module.exports = __webpack_public_path__ + "img/More.2b1ee53c.svg";